var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.21429 6.5C2.662 6.5 2.21429 6.94772 2.21429 7.5V25C2.21429 25.5523 2.662 26 3.21429 26H27.7857C28.338 26 28.7857 25.5523 28.7857 25V7.5C28.7857 6.94772 28.338 6.5 27.7857 6.5H3.21429ZM1 0C0.447716 0 0 0.447715 0 1V5.5C0 6.05228 0.447715 6.5 1 6.5H30C30.5523 6.5 31 6.05228 31 5.5V1C31 0.447715 30.5523 0 30 0H1Z",
    fill: "#93979F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 1V6.07778C31 6.63006 30.5523 7.07778 30 7.07778H1C0.447715 7.07778 0 6.63006 0 6.07778V1C0 0.447715 0.447716 0 1 0H30C30.5523 0 31 0.447716 31 1Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.332 16.1777L13.432 19.2111L20.6654 12.1333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIcon);
export default __webpack_public_path__ + "static/media/ArchiveIcon.7c75747a.svg";
export { ForwardRef as ReactComponent };